import React from 'react'

const ConditionallyRender = ({ children, when }) => {
    return (
        <>
            {when ? children : null}
        </>)
}
export default ConditionallyRender